import Vue from 'vue'
import Vuex from 'vuex'

import moment from "moment"

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: "",
    worker: {},
    fromUrlName: "",
    logFlag: "",

    constantShiftChangeAutoMsg: "",
    constantClosingTime: "",
    constantMaxOverTime: "",
    constantShiftChangeLimitDays: "",
    constantDesiredShiftMsg: "",
    constantDesiredShiftCode: "",
    constantWorkerNumbers: [],
    constantAppUpdateUserId: "",
    constantWorksheetTimeUnit: null,

    shiftAdjustSelectedYearMonth: {},

    shiftAdjustAllWorkerShifts: [],

    hasInputAndNotSubmited: false,
    currentLocation: {},
    locations: [],
  },
  mutations: {
    setShiftSelectedYearMonth(state, payload) {

      state.shiftAdjustSelectedYearMonth = payload.yearMonth
    },
    setToken(state, payload) {
      state.token = payload.token
      state.logFlag = "login"
    },
    setWorker(state, payload) {
      state.worker = payload.worker
    },
    setFromUrlName(state, payload) {
      state.fromUrlName = payload.fromUrlName
    },
    setConstantShiftChangeAutoMsg(state, payload) {
      state.constantShiftChangeAutoMsg = payload.shiftChangeAutoMsg
    },
    setConstantWorkSheetLimitDays(state, payload) {
      state.constantClosingTime = payload.closingTime
      state.constantMaxOverTime = payload.maxOverTime
    },
    setConstantShiftChangeLimitDays(state, payload) {
      state.constantShiftChangeLimitDays = payload.shiftChangeLimitDays
    },
    setConstantDesiredShiftMsg(state, payload) {
      state.constantDesiredShiftMsg = payload.desiredShiftMsg
      state.constantDesiredShiftCode = payload.desiredShiftCode
    },
    setConstantWorkerNumbers(state, payload) {
      state.constantWorkerNumbers = payload.workerNumbers
    },
    setConstantAppUpdateUserId(state, payload) {
      state.constantAppUpdateUserId = payload.appUpdateUserId
    },
    setWorksheetTimeUnit(state, payload) {
      let result = payload.worksheetTimeUnit;
      // 1,5,10,15,20,30ではない値の場合15分刻み
      if (result == 1 || result == 5 || result == 10 || result == 15 || result == 20 || result == 30) {
        state.constantWorksheetTimeUnit = result;
      }else{
        state.constantWorksheetTimeUnit = 15;
      }
    },
    logout(state) {

      state.logFlag = "logout"

      state.token = ""
      state.worker = {}
      state.fromUrlName = ""

      state.constantShiftChangeAutoMsg = ""
      state.constantClosingTime = ""
      state.constantMaxOverTime = ""
      state.constantShiftChangeLimitDays = ""
      state.constantDesiredShiftMsg = ""
      state.constantDesiredShiftCode = ""
      state.constantWorkerNumbers = []
      state.constantAppUpdateUserId = ""
      state.constantWorksheetTimeUnit = null

      state.shiftAdjustSelectedYearMonth = {}

      state.shiftAdjustAllWorkerShifts = []

      state.hasInputAndNotSubmited = false

      state.currentLocation = {}
      state.locations = []

      sessionStorage.removeItem("store");
    },

    resetState(state) {

      state.worker = {}

      state.constantShiftChangeAutoMsg = ""
      state.constantClosingTime = ""
      state.constantMaxOverTime = ""
      state.constantShiftChangeLimitDays = ""
      state.constantDesiredShiftMsg = ""
      state.constantDesiredShiftCode = ""
      state.constantWorkerNumbers = []
      state.constantAppUpdateUserId = ""
      state.constantWorksheetTimeUnit = null

      state.shiftAdjustSelectedYearMonth = {}

      state.shiftAdjustAllWorkerShifts = []

      state.hasInputAndNotSubmited = false

      state.currentLocation = {}

      sessionStorage.removeItem("store");
    },
    setShiftAdjustAllWorkerShifts(state, payload) {
      for (let _addMonthlyWorkerShifts of payload.monthlyWorkerShifts) {
        let isAdd = true
        for (let i = 0; i < state.shiftAdjustAllWorkerShifts.length; i++) {
          if (moment(new Date(_addMonthlyWorkerShifts.yearMonth)).diff(moment(new Date(state.shiftAdjustAllWorkerShifts[i].yearMonth)), 'days') == 0) {
            state.shiftAdjustAllWorkerShifts[i] = _addMonthlyWorkerShifts
            isAdd = false
            break
          }
        }
        if (isAdd) {
          state.shiftAdjustAllWorkerShifts.push(_addMonthlyWorkerShifts)
        }
      }
    },
    setHasInputAndNotSubmited(state, payload) {
      state.hasInputAndNotSubmited = payload.hasInputAndNotSubmited
    },
    setShiftAdjustAllWorkerShiftsByWorkerShift(state, payload) {
      let year = moment(new Date(payload.workerShift.workingDay)).year()
      let month = moment(new Date(payload.workerShift.workingDay)).month()

      for (let i = 0; i < state.shiftAdjustAllWorkerShifts.length; i++) {
        let _yearMonth = moment(new Date(state.shiftAdjustAllWorkerShifts[i].yearMonth))
        let _year = _yearMonth.year()
        let _month = _yearMonth.month()
        if (year == _year && month == _month) {
          for (let j = 0; j < state.shiftAdjustAllWorkerShifts[i].workerShifts.length; j++) {
            if (moment(new Date(payload.workerShift.workingDay)).diff(moment(new Date(state.shiftAdjustAllWorkerShifts[i].workerShifts[j].workingDay)), 'days') == 0) {
              state.shiftAdjustAllWorkerShifts[i].workerShifts[j] = payload.workerShift
            }
          }
          break
        }
      }
    },
    setShiftAdjustAllWorkerShiftsByWorkingDay(state, payload) {

      let year = moment(new Date(payload.workingDay)).year()
      let month = moment(new Date(payload.workingDay)).month()

      for (let i = 0; i < state.shiftAdjustAllWorkerShifts.length; i++) {
        let _yearMonth = moment(new Date(state.shiftAdjustAllWorkerShifts[i].yearMonth))
        let _year = _yearMonth.year()
        let _month = _yearMonth.month()
        if (year == _year && month == _month) {
          for (let j = 0; j < state.shiftAdjustAllWorkerShifts[i].workerShifts.length; j++) {
            if (moment(new Date(payload.workingDay)).diff(moment(new Date(state.shiftAdjustAllWorkerShifts[i].workerShifts[j].workingDay)), 'days') == 0) {

              switch (payload.editType) {
                case 2:
                  state.shiftAdjustAllWorkerShifts[i].workerShifts[j].displayMark = ""
                  state.shiftAdjustAllWorkerShifts[i].workerShifts[j].workerTimeSheetId = 999999
                  break
                case 3:
                  state.shiftAdjustAllWorkerShifts[i].workerShifts[j].displayMark = ""
                  state.shiftAdjustAllWorkerShifts[i].workerShifts[j].enableSubmitTimeSheet = 0
                  break
              }
              break
            }
          }
          break
        }
      }
    },
    setCurrentLocation(state, payload) {
      state.currentLocation = payload.currentLocation
    },
    setLocations(state, payload) {
      state.locations = payload.locations
    },
  },
  actions: {

  }
})
